<ion-header>
    <ion-toolbar>
        <ion-title>{{tr('@title_crop_image')}}</ion-title>
        <ion-buttons slot="end">
            <ion-button [attr.data-id]="'image-close-button'" (click)="CloseModal()">
                <ion-icon slot="icon-only" name="close"></ion-icon>
            </ion-button>        
        </ion-buttons>
    </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
    <div class="nno-scrollbar-y" [ngClass]="{ 'mobile': view.Mobile, 'show': view.Scrollbar }">
        <upp-crop-image [attr.data-id]="'image-crop-control'" [image]="image" [cropHeight]="height" [cropWidth]="width" (Cropped)="OnCrop($event)"></upp-crop-image>
    </div>
</ion-content>
